import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Mail illustration for the "this address already exists" screen. Export from
 * design, pasted as a component because that is how illustrations live in this
 * repo. The pale circle is part of the asset, so whoever places it does not add
 * its own background.
 */
export function MailIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 170 170'
      fill='none'
    >
      <g filter='url(#filter0_i_540_6130)'>
        <rect
          width='170'
          height='170'
          rx='85'
          fill='#F0F5FF'
        />
        <path
          d='M128.783 85.0117H41.4812L52.283 63.7119H119.165L125.232 67.5577C127.259 68.932 128.173 69.9284 128.783 72.7348V85.0117Z'
          fill='#2877E0'
        />
        <path
          d='M41.4799 85.0117H123.473L113.328 63.7119H50.513L44.8152 67.5577C42.9113 68.932 42.0528 69.9284 41.4799 72.7348V85.0117Z'
          fill='#2877E0'
        />
        <g filter='url(#filter1_d_540_6130)'>
          <path
            d='M81.6653 44.1223L59.0016 59.7843C54.1603 63.1299 56.5279 70.7203 62.4127 70.7203H108.846C114.799 70.7203 117.118 62.9856 112.147 59.7101L88.3777 44.0482C86.3345 42.7019 83.6784 42.7312 81.6653 44.1223Z'
            fill='#2877E0'
          />
        </g>
        <g filter='url(#filter2_d_540_6130)'>
          <path
            d='M49.9255 101.784V56.8486C49.9255 51.3258 54.4027 46.8486 59.9255 46.8486H110.333C115.856 46.8486 120.333 51.3258 120.333 56.8486V101.784C120.333 107.306 115.856 111.784 110.333 111.784H59.9255C54.4027 111.784 49.9255 107.306 49.9255 101.784Z'
            fill='white'
          />
        </g>
        <g filter='url(#filter3_d_540_6130)'>
          <path
            d='M41.4941 125.906V76.2857C41.4941 74.6384 43.3741 73.6974 44.6928 74.6847L84.0725 104.166C84.7849 104.7 85.7641 104.698 86.4749 104.162L125.56 74.7046C126.878 73.7114 128.764 74.6515 128.764 76.3018V125.906C128.764 127.011 127.869 127.906 126.764 127.906H43.4941C42.3896 127.906 41.4941 127.011 41.4941 125.906Z'
            fill='#3E8FFA'
          />
        </g>
        <path
          d='M44.1562 127.907L56.9692 117.553L111.945 116.665L126.397 127.907H44.1562Z'
          fill='#2877E0'
        />
        <path
          d='M80.702 97.8659L57.0943 117.271C52.7436 120.848 55.2724 127.906 60.9043 127.906H108.725C114.394 127.906 116.901 120.77 112.477 117.225L88.2643 97.8191C86.0497 96.0442 82.8944 96.0637 80.702 97.8659Z'
          fill='#2877E0'
        />
        <rect
          x='61.314'
          y='56.0195'
          width='37.5705'
          height='1.77498'
          rx='0.887492'
          fill='#DFEAFB'
        />
        <rect
          x='61.314'
          y='61.9365'
          width='17.454'
          height='1.77498'
          rx='0.887492'
          fill='#DFEAFB'
        />
        <rect
          x='61.314'
          y='67.5566'
          width='52.3621'
          height='1.77498'
          rx='0.887492'
          fill='#DFEAFB'
        />
        <rect
          x='61.314'
          y='75.249'
          width='52.3621'
          height='1.77498'
          rx='0.887492'
          fill='#DFEAFB'
        />
        <rect
          x='61.314'
          y='82.9404'
          width='50.5871'
          height='1.77498'
          rx='0.887492'
          fill='#DFEAFB'
        />
      </g>
      <defs>
        <filter
          id='filter0_i_540_6130'
          x='0'
          y='0'
          width='179'
          height='190'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_540_6130'
          />
        </filter>
        <filter
          id='filter1_d_540_6130'
          x='54.4014'
          y='43.0586'
          width='72.4553'
          height='44.6621'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_540_6130'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_540_6130'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_540_6130'
          x='47.9255'
          y='46.8486'
          width='84.4077'
          height='81.9346'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_540_6130'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_540_6130'
            result='shape'
          />
        </filter>
        <filter
          id='filter3_d_540_6130'
          x='39.4941'
          y='74.2822'
          width='101.27'
          height='70.624'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_540_6130'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_540_6130'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
